import React from "react";
import { SemanticSIZES } from "semantic-ui-react";
import { SocialNetworkIcon } from "@/components/SocialNetworkIcon";
import { Tooltip } from "@/components/ui/tooltip";
import { socialNetworkNames } from "@/interfaces";
import { Review } from "@/services/bedrock";

export function ReviewSourceIcon({
  sourceSystem,
  size = "small",
}: {
  sourceSystem: Review["sourceSystem"];
  size?: SemanticSIZES;
}) {
  const name = socialNetworkNames[sourceSystem];

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <span className="inline-flex cursor-default" aria-label={name}>
            <SocialNetworkIcon socialNetworkId={sourceSystem} size={size} />
          </span>
        }
      />
      <Tooltip.Content>{name}</Tooltip.Content>
    </Tooltip>
  );
}
